import { SuggestionsType } from '@analytics/const';
import { Injectable, Injector } from '@angular/core';
import { CustomBaseStore } from '@city/const';
import { BaseStoreFacade } from '@city/data-access';
import { filter, take } from 'rxjs/operators';
import { AnalyticsService } from './analytics.service';
import { ProductListAnalyticsService } from './product-list';

@Injectable({ providedIn: 'root' })
export class SearchAnalyticsService extends ProductListAnalyticsService {
  constructor(
    private analyticsService: AnalyticsService,
    private baseStoreFacade: BaseStoreFacade,
    injector: Injector,
  ) {
    super(injector);
  }

  onLaunchSearchResultWithoutSuggestion(): void {
    this.baseStoreFacade
      .getActiveBaseStore()
      .pipe(filter(Boolean), take(1))
      .subscribe((baseStore: CustomBaseStore) => {
        this.analyticsService.sendEvent({
          event: 'common_event',
          eventCateg: 'Поиск на сайте',
          eventAction: 'Поиск без подсказок',
          eventLabel: baseStore.code,
          eventNonInteraction: false,
        });
      });
  }

  onLaunchSearch(searchText: string): void {
    if (searchText) {
      this.baseStoreFacade
        .getActiveBaseStore()
        .pipe(filter(Boolean), take(1))
        .subscribe((baseStore: CustomBaseStore) => {
          this.analyticsService.sendEvent({
            event: 'view_search_results',
            search_query: searchText,
            city: baseStore.name,
          });
        });
    }
  }

  onClickSuggestion({
    searchPhrase,
    suggestionType,
    suggestionValue,
  }: {
    searchPhrase: string;
    suggestionType: SuggestionsType;
    suggestionValue: string;
  }): void {
    this.baseStoreFacade
      .getActiveBaseStore()
      .pipe(filter(Boolean), take(1))
      .subscribe((baseStore: CustomBaseStore) => {
        this.analyticsService.sendEvent({
          event: 'common_event',
          eventCateg: 'Подсказки в поиске',
          eventAction: ['Клик', searchPhrase, suggestionType, suggestionValue].filter(Boolean).join('_'),
          eventLabel: baseStore.name,
          eventNonInteraction: false,
        });
      });
  }
}
